import { render } from "./RegionDashboardsRepresentativeAbroadInfoTable.vue?vue&type=template&id=61e7feb9&ts=true"
import script from "./RegionDashboardsRepresentativeAbroadInfoTable.vue?vue&type=script&lang=ts"
export * from "./RegionDashboardsRepresentativeAbroadInfoTable.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__